import { DeliveryOptionService } from './../../test/delivery-option.service';
import { DeliveryOption } from './../../test/DeliveryOption';
import { DeliveryOptionDao } from './../../test/delivery-option.dao';
import { Component, OnInit, Inject } from '@angular/core';
import { PropertyType } from 'src/app/product/PropertyType';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lsu-edit-delivery-option',
  templateUrl: './edit-delivery-option.component.html',
  styleUrls: ['./edit-delivery-option.component.scss']
})
export class EditDeliveryOptionComponent implements OnInit {
  
  public loading = false
  dao : DeliveryOptionDao;
  propertyTypes : PropertyType[];
  public formGroup: FormGroup;
  constructor(
    public deliveryOptionService : DeliveryOptionService,
    private afs: AngularFirestore, private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditDeliveryOptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.propertyTypes = [];
    this.formGroup = this.fb.group({
      name: this.fb.control("", [Validators.required]),
      price: this.fb.control("", [Validators.required]),
      quantity: this.fb.control("", [Validators.required]),
    });
    if (data) {
      this.formGroup.setValue({
        name: data.name,
        price: data.price,
        quantity: data.quantity,
      })
    }
  }

  //Use getters for cleaner HTML code
  get name() {
    return this.formGroup.get('name')
  }

  get price() {
    return this.formGroup.get('price')
  }

  get quantity() {
    return this.formGroup.get('quantity')
  }

 async ngOnInit() {
    this.dao = new DeliveryOptionDao(this.deliveryOptionService)
    await this.dao.initialize()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public async updateDeliveryOption(): Promise<void> {
    this.loading = true
    const customer = this.formGroup.value as DeliveryOption;
    await this.deliveryOptionService.updateDeliveryOption(customer, this.data._id)
    this.dialogRef.close({
      ...this.data,
      ...customer,
    })
  }

  // public updateDeliveryOption(){
  //   this.dao.loading.next(true)
  //   let valuetest = this.formGroup.value;
  //   const deliveryOption = valuetest as DeliveryOption;
  //    this.dao.updateDeliveryOption(deliveryOption, this.data._id)
  //   this.dao.addItem(deliveryOption)
  //   this.dao.loading.next(false)
  // }
}
